import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default new Vuex.Store({
  state: {
    forcedLogin: false,
    realName: "",
    totalPrice:0,
    tagList:[],
    userInfo:{
      // realName:''
      username: ''
    },
    platformNameList: [],
    visitorPhone: '' // 游客手机号

  },
  mutations: {
		update(state,[key,value]){
			state[key]=value;
		},
  },
  actions: {},
  modules
})




// WEBPACK FOOTER //
// ./src/store/index.js